// @flow
import { reduce, get } from "lodash";
import type {
  TalentPickData,
  TalentPickDataRunners,
  TalentPickServiceData
} from "@tvg/types/TalentPicks";
import type { TalentPickGraphData } from "@tvg/types/Race";

export const mapSelections = (
  selections: TalentPickDataRunners[][]
): Array<Array<{ order: "" }>> =>
  selections.map((selection: TalentPickDataRunners[]) =>
    selection.map((runner: TalentPickDataRunners) =>
      get(runner, "order", "").toString()
    )
  );

export const mapSelectionsToString = (selections: string[][]) =>
  selections
    .map((selection: string[]) =>
      selection.map((runner: string) => runner).join(",")
    )
    .join("-");

export const mapTalentPickFromGraph = (
  pick: TalentPickGraphData
): TalentPickData => ({
  id: pick.id,
  selections: mapSelections(pick.selections),
  favorites: mapSelections(pick.favorites),
  amount: pick.amount,
  price: pick.price,
  wagerType: {
    id: pick.wagerType.type.id,
    abbreviation: pick.wagerType.type.code,
    legCount: pick.wagerType.legCount,
    isBox: pick.wagerType.isBox,
    isKey: pick.wagerType.isKey,
    isWheel: pick.wagerType.isWheel
  },
  track: pick.race.track.code,
  trackName: pick.race.track.name,
  race: +pick.race.number,
  raceId: pick.race.id,
  raceType: pick.race.type.code,
  raceStatus: pick.race.status.code,
  talent: pick.talent,
  published: true,
  racePostTime: pick.race.postTime,
  mtp: pick.race.mtp,
  highlighted: pick.race.highlighted
});

export const mapTalentPickFromService = (
  pick: TalentPickServiceData
): TalentPickData => ({
  ...pick,
  selections: mapSelections(pick.selections),
  favorites: mapSelections(pick.favorites)
});

export const mapTalentPicksListFromGraph = (
  talentPicks: TalentPickGraphData[]
): TalentPickData[] =>
  reduce(
    talentPicks,
    (list: TalentPickData[], pick: TalentPickGraphData) => {
      list.push(mapTalentPickFromGraph(pick));

      return list;
    },
    []
  );

export const mapTalentPicksListFromService = (
  talentPicks: TalentPickServiceData[]
): TalentPickData[] =>
  reduce(
    talentPicks,
    (list: TalentPickData[], pick: TalentPickServiceData) => {
      list.push(mapTalentPickFromService(pick));

      return list;
    },
    []
  );
